//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Action from "../action";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      config: {
        copy: {
          icon: "far fah fa-lg fa-copy",
          color: "#183153"
        },
        email: {
          icon: "far fah fa-lg fa-envelope",
          color: "#333333"
        },
        facebook: {
          icon: "fab fah fa-lg fa-facebook-f",
          color: "#1877f2"
        },
        hackernews: {
          icon: "fab fah fa-lg fa-hacker-news",
          color: "#ff4000"
        },
        instapaper: {
          icon: "fas fah fa-lg fa-italic",
          color: "#428bca"
        },
        line: {
          icon: "fab fah fa-lg fa-line",
          color: "#00c300"
        },
        linkedin: {
          icon: "fab fah fa-lg fa-linkedin",
          color: "#007bb5"
        },
        messenger: {
          icon: "fab fah fa-lg fa-facebook-messenger",
          color: "#0084ff"
        },
        pinterest: {
          icon: "fab fah fa-lg fa-pinterest",
          color: "#bd081c"
        },
        reddit: {
          icon: "fab fah fa-lg fa-reddit-alien",
          color: "#ff4500"
        },
        telegram: {
          icon: "fab fah fa-lg fa-telegram-plane",
          color: "#0088cc"
        },
        tumblr: {
          icon: "fab fah fa-lg fa-tumblr",
          color: "#35465c"
        },
        twitter: {
          icon: "fab fah fa-lg fa-twitter",
          color: "#1da1f2"
        },
        weibo: {
          icon: "fab fah fa-lg fa-weibo",
          color: "#e9152d"
        },
        whatsapp: {
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366"
        },
        wordpress: {
          icon: "fab fah fa-lg fa-wordpress",
          color: "#21759b"
        }
      }
    };
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      if (this.spec.onClick) {
        var parentElement = this.$el.parentElement; // remove default event listener

        this.$el.replaceWith(this.$el.cloneNode(true)); // manually attach event listener because @click not working

        parentElement.querySelector("a.".concat(this.$el.classList[0])).addEventListener("click", function (e) {
          e.preventDefault();
          Action.execute(_this.spec.onClick, _this);
        });
      }
    },
    styles: function styles() {
      var styles = this.$styles();
      styles["backgroundColor"] = this.config[this.spec.network].color;
      return styles;
    }
  }
};